import { createApp } from 'vue'
import './css/theme.less'
import './css/common.less'
import App from './App.vue'
import i18n from '@/languages/i18n'
import { setDebug } from '../libs/debug'
setDebug()
createApp(App)
  .use(i18n)
  .mount('#app')
